import { cn } from '@lib/cn'
import { FC } from 'react'

type Props = {
  sources: string[]
  activeIndex: number
  setIndex: (index: number) => void
}

const Thumbnails: FC<Props> = ({ sources, activeIndex, setIndex }) => {
  return (
    <nav className="hidden w-full overflow-x-auto sm:flex">
      {sources.map((src, index) => (
        <button
          className={cn(
            'mr-[5px] inline-block h-[60px] w-[90px] flex-shrink-0 border border-solid border-white/80 bg-transparent outline-none transition-opacity duration-150',
            index === activeIndex ? 'opacity-50' : 'opacity-100',
          )}
          key={src}
          onClick={() => setIndex(index)}
        >
          <img className="h-full w-full object-cover" src={src} alt="" />
        </button>
      ))}
    </nav>
  )
}

export default Thumbnails
